import { PhosphorCar } from "components/Atoms/PhosphorIcon";
import React from "react";
import { formatKm } from "shared/utils/distanceUtils";
import { getPickupLocationType } from "shared/utils/enumutils";
import { TravelHeaderLayout } from "./TravelHeaderLayout";

interface GroundHeaderProps {
  groundTransport: server.dto.GroundTransport
  passengers: server.dto.ContactSmallV2[]
}

export const GroundHeader = ({ groundTransport, passengers }: GroundHeaderProps) => {
  const distanceInMeters = groundTransport.directions.distanceInMeters;

  return <TravelHeaderLayout
    icon={<PhosphorCar iconColor="white" iconSize="large" />}
    departure={{ name: getPickupLocationType(groundTransport.startPickupLocationType, serverReference).text, address: groundTransport.startGooglePlaceAddress }}
    arrival={{ name: getPickupLocationType(groundTransport.endPickupLocationType, serverReference).text, address: groundTransport.endGooglePlaceAddress }}
    dateTime={groundTransport.dateTime}
    detail={distanceInMeters ? formatKm({ meter: distanceInMeters }, 1) : undefined}
    durationInMinutes={groundTransport.durationInMinutes}
    artist={groundTransport.artist}
    passengers={passengers.map(p => p.name.fullName)}
  />;
};
